import store from '@/store'
import OncallErrorReport from '@/pages/oncallerrorreport';
import LoginOncall from '@/pages/login_oncall';

const requireOncallAuth = async (to, from, next) => {
  if (store.getters.authStatusOnCall === null) {
    await store.dispatch('checkAuthStatusOnCall');
  }
  if (store.getters.authStatusOnCall === false) {
    next({
      path: '/login-oncall',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
};

export default [
  {
    path: '/',
    component: OncallErrorReport,
    name: 'OncallErrorReport',
    beforeEnter: requireOncallAuth,
  },
  {
    path: '/login-oncall',
    name: 'LoginOncall',
    component: LoginOncall,
  }
]
